﻿angular.module('projectModule')
    .service('ntaRounding',
        ['$log', '$location',
function ($log,   $location) {
    'use strict';
    const vm = this;

    const _numberFormats = new Map();

    const decRound = {
        "R001": 0,
        "R002": 1,
        "R003": 2,
        "R004": 3,
        "R005": 4,
        "R006": 0,
        "R007": 1,
        "R008": 2,
        "R009": 3,
        "R010": 3,
        "R011": 2,
        "R013": 3,
        "R014": 2,
        "R015": 1,
        "R016": 0,
        "R017": 3,
        "R018": 0,
        "R019": 4,
        "R023": 0,
        "R024": 0
    };

    vm.parseFloat = function (text, defaultValue = NaN) {
        const result = Number.parseFloat(String(text).replace(',', '.'));
        if (!isNaN(result))
            return result;
        else
            return defaultValue;
    };

    vm.getDecimals = function (flvalue, rounding) {
        return rounding === 'R012'
            ? flvalue > 1.0 ? 1 : 2
            : decRound[rounding];
    };

    vm.ntaround = function (value, rounding) {

        if (rounding === 'R000' || !rounding) {
            return value;
        }

        value = Number(value);

        const decimals = vm.getDecimals(value, rounding);
        const multiplier = 10 ** decimals;

        // round UP to decimals
        if (rounding === "R001" || rounding === "R002" || rounding === "R003" || rounding === "R004" || rounding === "R005") {
            const shifted = value * multiplier;
            const prerounded = Math.round(shifted * 10000) / 10000; // afronding tegen floating-point onnauwkeurigheid
            return Math.ceil(prerounded) / multiplier;
        }

        // round DOWN to decimals
        if (rounding === "R006" || rounding === "R007" || rounding === "R008" || rounding === "R009" || rounding === "R010") {
            const shifted = value * multiplier;
            const prerounded = Math.round(shifted * 10000) / 10000; // afronding tegen floating-point onnauwkeurigheid
            return Math.floor(prerounded) / multiplier;
        }

        // round DOWN to a multiple of 0,05 (or 5)
        if (rounding === "R011" || rounding === "R018") {
            const shifted = value * multiplier;
            const prerounded = Math.round(shifted * 10000) / 10000;

            // Rond naar beneden naar veelvoud van 5
            const scaleFactor = 5;
            const roundedScaled = Math.floor(prerounded / scaleFactor) * scaleFactor;

            // Converteer terug naar het oorspronkelijke aantal decimalen
            return roundedScaled / multiplier;
        }

        // round DOWN to a multiple of 0.025
        if (rounding === "R013") {
            const shifted = value * multiplier;
            const prerounded = Math.round(shifted * 10000) / 10000;

            // Rond naar beneden naar veelvoud van 25
            const scaleFactor = 25;
            const roundedScaled = Math.floor(prerounded / scaleFactor) * scaleFactor;

            // Converteer terug naar het oorspronkelijke aantal decimalen
            return roundedScaled / multiplier;
        }

        // round HALF UP to decimals
        if (rounding === "R012" || rounding === "R014" || rounding === "R015" || rounding === "R016" || rounding === "R017" || rounding === "R019") {
            const shifted = value * multiplier;  // aantal relevante decimalen opschuiven om af te kunnen ronden
            const floored = Math.floor(shifted);
            const remainder = Math.round((shifted - floored) * 10000) / 10000; // afronding tegen floating-point onnauwkeurigheid
            const rounded = remainder >= 0.5
                ? Math.ceil(shifted)
                : floored;
            return rounded / multiplier; // terugschuiven
        }

        // round HALF UP to a multiple of 10
        if (rounding === 'R023') {
            return Math.round(value / 10) * 10;
        }

        // round HALF UP to a multiple of 50
        if (rounding === 'R024') {
            return Math.round(value / 50) * 50;
        }

        // Round up to 2 significant digits
        if (rounding === "R020") {
            const sigNums = [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 44, 48, 52, 56, 60, 65, 70, 75, 80, 85, 90, 95, 100];
            const strVal = value.toString().split('');

            // Het eerste cijfer zoeken dat geen 0 is
            let hasDot = false;
            let indexFirstDigit = 0;
            for (let index = 0; index < strVal.length; index++) {
                if (strVal[index] === '0') {
                    continue;
                }
                else if (strVal[index] === '.') {
                    hasDot = true;
                    continue;
                }
                indexFirstDigit = index;
                break;
            }

            let numberToRound;

            // Het getal samenstellen dat wordt afgerond
            if (indexFirstDigit === strVal.length - 1) {
                numberToRound = strVal[indexFirstDigit] + '0';
            }
            else if (strVal[indexFirstDigit + 1] === '.') {
                numberToRound = strVal[indexFirstDigit] + strVal[indexFirstDigit + 2];
            }
            else {
                numberToRound = strVal[indexFirstDigit] + strVal[indexFirstDigit + 1];
            }

            // Het getal in de lijst zoeken waarnaar moet worden afgerond
            for (let index = 0; index < sigNums.length; index++) {
                if (parseInt(numberToRound) <= sigNums[index]) {
                    numberToRound = sigNums[index].toString();
                    break;
                }
            }

            // Het afgeronde getal terugzetten in de array
            if (indexFirstDigit === strVal.length - 1) { // Als het eerste cijfer ongelijk aan 0 ook de laatste is
                strVal[indexFirstDigit] = numberToRound[0];
                if (hasDot) { // Plak het tweede cijfer van het afgeronde getal achter de eerste
                    strVal.push(numberToRound[1]);
                }
                else { // Plak een punt en het tweede cijfer van het afgeronde getal achter de eerste
                    strVal.push('.');
                    strVal.push(numberToRound[1]);
                }
            }
            else if (strVal[indexFirstDigit + 1] === '.') { // Als er een komma tussen het eerste en tweede cijfer valt
                if (numberToRound === '100') { // Als is afgerond op 100, moet er een 1 voor het getal
                    strVal.unshift('1');
                    strVal[indexFirstDigit + 1] = '0';
                }
                else { // Geen 100: eerste en tweede cijfer vervangen door afgerond getal
                    strVal[indexFirstDigit] = numberToRound[0];
                    strVal[indexFirstDigit + 2] = numberToRound[1];
                }

                // Alle volgende cijfers op 0 zetten
                for (let index = indexFirstDigit + 3; index < strVal.length; index++) {
                    if (strVal[index] === '.') {
                        continue;
                    }
                    strVal[index] = '0';
                }
            }
            else { // Er is meer dan 1 relevant cijfer en is niet van de tweede gescheiden door een komma
                if (numberToRound === '100' && !hasDot) { // Als is afgerond op 100, moet er een 1 voor het getal
                    strVal.unshift('1');
                    strVal[indexFirstDigit + 1] = '0';
                }
                else if (numberToRound === '100' && hasDot) { // Als is afgerond op 100 en er een komma is, moet er een 1 vooraan op de juiste plek worden gezet
                    if (strVal[indexFirstDigit - 1] === '.') { // 1 voor de komma
                        strVal[indexFirstDigit - 2] = '1';
                        strVal[indexFirstDigit] = '0';
                        strVal[indexFirstDigit + 1] = '0';
                    }
                    else { // 1 ergens achter de komma
                        strVal[indexFirstDigit - 1] = '1';
                        strVal[indexFirstDigit] = '0';
                        strVal[indexFirstDigit + 1] = '0';
                    }
                }
                else { // Geen 100: eerste en tweede cijfer vervangen door afgerond getal
                    strVal[indexFirstDigit] = numberToRound[0];
                    strVal[indexFirstDigit + 1] = numberToRound[1];
                }

                // Alle volgende cijfers op 0 zetten
                for (let index = indexFirstDigit + 2; index < strVal.length; index++) {
                    if (strVal[index] === '.') {
                        continue;
                    }
                    strVal[index] = '0';
                }
            }

            // Value weer in elkaar zetten
            const strValue = strVal.join('');
            return parseFloat(strValue);
        }

        // Round down to 2 significant digits
        if (rounding === "R021") {
            //-- TODO 2020-02-24 VO: onderstaande code moet gelijk worden aan code R020 maar dan afronding naar beneden.
        }

        $log.warn('Kan', value, 'niet afronden volgens', rounding, '!');
        throw new Error(`Rounding ${rounding} not implemented!`);
    };

    vm.roundAndAddZeros = function (prop, propdata, rounding = null) {
        if (prop.PropertyType === 1 && propdata && propdata.Value && propdata.Value !== "n.v.t.") {
            if (!rounding) {
                rounding = prop.Rounding;
            }

            const strresult = vm.roundAndAddZerosNewValue(null, propdata.Value, rounding);

            if (typeof strresult === 'string') {
                propdata.Value = strresult;
            }
        }
    };

    vm.roundAndAddZerosNewValue = function (prop, newValue, rounding = null) {
        let strresult = null;
        if (!prop || prop.PropertyType === 1) {
            if (!rounding && prop) {
                rounding = prop.Rounding;
            }

            let flvalue = vm.parseFloat(newValue);

            if (isNaN(flvalue)) {
                return null;
            }

            // Het aantal decimalen bepalen vóór het afronden (ivm R012)
            const decimals = vm.getDecimals(flvalue, rounding);

            flvalue = vm.ntaround(flvalue, rounding);
            strresult = flvalue.toString().replace('.', ",");

            if (rounding === 'R020') {
                if (strresult.length === 1) {
                    strresult += ',0';
                }
            } else {
                //0-en aanvullen obc decimals
                const len = strresult.length;
                let indx = strresult.indexOf(",");
                indx = indx === -1 ? len : indx + 1; //geen komma -> index = lengte, wel komma -> index + 1 omdat de komma niet moet worden meegeteld...
                const numzero = decimals - (len - indx);
                if (len === indx && numzero > 0) {
                    strresult += ",";
                }
                for (var i = 0; i < numzero; i++) {
                    strresult += "0";
                }
            }
        }
        return strresult;
    };

    vm.formatNumber = function (value, decimals, ifNull = "--") {
        if (typeof value === "number") {
            return getNumberFormat(decimals).format(value);
        } else if (value === null) {
            return ifNull;
        } else {
            return value;
        }
    };

    function getNumberFormat(decimals) {
        decimals = decimals || 0;
        let numberFormat = _numberFormats.get(decimals);
        if (!numberFormat) {
            numberFormat = new Intl.NumberFormat("nl-NL", {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals,
            });
            _numberFormats.set(decimals, numberFormat);
        }
        return numberFormat;
    }


    if (location.hostname === 'localhost') {

        vm.runTests = function (showAll = false) {
            const roundingTests = [
                // rounding, value, expectedNumber, expectedText
                ['R001', 0.9,           1,      '1'],
                ['R001', 1.0,           1,      '1'],
                ['R001', 1.0000001,     1,      '1'],
                ['R001', 1.04,          2,      '2'],
                ['R001', 1.05,          2,      '2'],
                ['R001', 1.1,           2,      '2'],

                ['R006', 0.9,           0,      '0'],
                ['R006', 0.999999,      1,      '1'],
                ['R006', 1.0,           1,      '1'],
                ['R006', 1.05,          1,      '1'],
                ['R006', 1.5,           1,      '1'],
                ['R006', 1.9,           1,      '1'],

                ['R010', 0.9,           0.9,    '0,900'],
                ['R010', 0.999999,      0.999,  '0,999'],
                ['R010', 0.999999999,   1,      '1,000'],
                ['R010', 1,             1,      '1,000'],
                ['R010', 1.0005,        1,      '1,000'],
                ['R010', 1.001,         1.001,  '1,001'],
                ['R010', 1.0019999,     1.001,  '1,001'],
                ['R010', 1.00199999,    1.002,  '1,002'],

                ['R011', 1.0499999,     1.05,   '1,05'],
                ['R011', 1.09,          1.05,   '1,05'],
                ['R011', 1.0999999,     1.1,    '1,10'],

                ['R012', 0.9,           0.9,    '0,90'],
                ['R012', 1,             1,      '1,00'],
                ['R012', 1.04999,       1,      '1,0'],
                ['R012', 1.0499999,     1.1,    '1,1'],

                ['R013', 1.248,         1.225,  '1,225'],
                ['R013', 1.252,         1.25,   '1,250'],

                ['R014', 1.90476,       1.90,   '1,90'],
                ['R014', 1.90499999,    1.91,   '1,91'],
                ['R014', 1.905,         1.91,   '1,91'],
            ];

            const problems = [], testResults = [];
            let successful = 0;
            for (const [rounding, value, expectedNumber, expectedText] of roundingTests) {
                const numericResult = vm.ntaround(value, rounding);
                const textResult = vm.roundAndAddZerosNewValue(null, value, rounding);
                const decimals = vm.getDecimals(value, rounding);
                const formattedResult = vm.formatNumber(numericResult, decimals);
                if (numericResult !== expectedNumber) {
                    problems.push({ test: 'ntaround', rounding, value, result: numericResult, expectedResult: expectedNumber });
                } else {
                    let success = true;
                    if (textResult !== expectedText) {
                        problems.push({ test: 'roundAndAddZeros', rounding, value, result: textResult, expectedResult: expectedText });
                        success = false;
                    }
                    if (formattedResult !== expectedText) {
                        problems.push({ test: 'formatNumber', rounding: rounding + ` (${decimals})`, value, result: formattedResult, expectedResult: expectedText });
                        success = false;
                    }
                    if (success) {
                        successful++;
                    }
                }
                if (showAll) {
                    testResults.push({ rounding, value, numericResult, textResult, formattedResult });
                }
            }

            if (problems.length) {
                $log.error('ntaRounding:', problems.length, `test${(problems.length === 1 ? '' : 's')} failed! (${successful} succeeded).`);
                console.table(problems);
            } else {
                $log.info('ntaRounding: all', successful, 'tests succeeded.');
            }
            if (showAll) {
                console.table(testResults);
            }
        };

        vm.runTests();

    } //-- end: if hostname === localhost

}]);
